import { render, staticRenderFns } from "./vertical-table-row.vue?vue&type=template&id=34a745f8&scoped=true"
import script from "./vertical-table-row.vue?vue&type=script&lang=js"
export * from "./vertical-table-row.vue?vue&type=script&lang=js"
import style0 from "./vertical-table-row.vue?vue&type=style&index=0&id=34a745f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a745f8",
  null
  
)

export default component.exports